import _get from 'lodash-es/get';
import { connect } from 'react-redux';

import ConfirmAdhocProgramCreation from './ConfirmAdhocProgramCreation';
import {
  createProgramInitiate,
  getProgramInfoInitiate,
} from '../../../../../../actions/programs';
import { openErrorToast } from '../../../../../../reducers/uiLogic';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const reviewProgMapping = _get(state, 'programs.reviewProgramMapping', {});
  const payableAmount = _get(reviewProgMapping, 'payable_amount', 0);
  const totalEmployees = _get(reviewProgMapping, 'total_employees', 0);
  const programInfo = _get(state, 'programs.programInfo', {});
  const executionDate = _get(
    reviewProgMapping,
    'program_details.start_date',
    '',
  );
  const programID = _get(reviewProgMapping, 'program_details.program_id', '');
  const programAmount = _get(reviewProgMapping, 'program_details.amount', 0);
  const pocEmail = _get(reviewProgMapping, 'program_details.poc_email', '');

  return {
    pocEmail,
    programAmount,
    totalEmployees,
    payableAmount,
    executionDate,
    programID,
    selectedWorkspace,
    creatingProgram:
      _get(state, 'apiState.CREATE_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.CREATE_PROGRAM.isIdle', true),
    createProgramSuccess: _get(state, 'apiState.CREATE_PROGRAM.success', false),
    programInfo,
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  createProgram: payload => dispatch(createProgramInitiate(payload)),
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
  showErrorToast: message => dispatch(openErrorToast(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmAdhocProgramCreation);
